import { useActorsWithFiltersQuery } from '@avatar/graphql/filterAvatars/operation.generated';
import {
  AvatarOrderByOrder,
  StudioProjectVersion,
} from '../../../../server/graphql/__generated.types';

interface UseProjectActorsListOptions {
  skip?: boolean;
}

const useUniversalProjectActors = (props: UseProjectActorsListOptions) => {
  const { skip } = props;
  const { data } = useActorsWithFiltersQuery({
    variables: {
      inputs: {
        projectVersion: StudioProjectVersion.Universal,
        orderBy: AvatarOrderByOrder.NameAsc,
      },
    },
    skip,
  });

  return data?.user.actors ?? [];
};

export default useUniversalProjectActors;
